module.exports = __webpack_public_path__ + "img/yellow.7b4e8876.svg";